import { defaultFetch } from "./baseApi"

export const importStaffPerMonth = async (projectId: string, month: string) => {
    return defaultFetch(`/v0/projects/${projectId}/staff/import`, {
        method: 'POST',
        body: JSON.stringify({ date: month }),
    })
}